import axios from 'axios';

export async function getMaterialsGRI(meterialsEpRoute) {
  try {
    const response = await axios.get(meterialsEpRoute);
    const rawData = response.data.data;

    // MATERIALS 301 (todos los materiales)

    const totalsByCategoria301 = rawData.reduce((acc, item) => {
      const categoria = item.CATEGORIA_MATERIAL || 'Desconocido';
      const cantidadKg = parseFloat(item.CANTIDAD_MATERIAL) || 0;
      acc[categoria] = (acc[categoria] || 0) + cantidadKg;
      return acc;
    }, {});

    const materials301 = Object.entries(totalsByCategoria301).map(([categoria, totalKg]) => {
      const cantidadTon = parseFloat((totalKg / 1000).toFixed(1));
      const incluyeEnvasado = categoria.toLowerCase().includes('envasado');

      return {
        material: categoria,
        cantidad: cantidadTon,
        unidad: 'ton',
        renovable: incluyeEnvasado ? 'sí' : 'no',
        proveedor: incluyeEnvasado ? 'Externo' : 'Interno',
        datos: 'Obtenido directamente',
        metodo: 'Protocolo GEI Estándard Corporativo'
      };
    });

    const totalCantidad301 = materials301.reduce((sum, item) => sum + item.cantidad, 0);
    materials301.push({
      material: 'Total de insumos utilizados',
      cantidad: parseFloat(totalCantidad301.toFixed(1)),
      unidad: '',
      renovable: '',
      proveedor: '',
      datos: '',
      metodo: ''
    });

    // MATERIALS 302 (solo reciclados, pero mostrando todos los tipos de 301)

    const reciclados = rawData.filter((item) => item.ES_RECICLADO === 'SI');

    const totalsByCategoria302 = reciclados.reduce((acc, item) => {
      const categoria = item.CATEGORIA_MATERIAL || 'Desconocido';
      const cantidadKg = parseFloat(item.CANTIDAD_MATERIAL) || 0;
      acc[categoria] = (acc[categoria] || 0) + cantidadKg;
      return acc;
    }, {});

    // Obtener las categorías desde materials301 (sin contar Total)
    const categorias301 = materials301.filter((item) => item.material !== 'Total de insumos utilizados').map((item) => item.material);

    const materials302 = categorias301.map((categoria) => {
      const totalKg = totalsByCategoria302[categoria] || 0;
      const cantidadTon = parseFloat((totalKg / 1000).toFixed(1));
      const tieneReciclado = totalKg > 0;
      const incluyeEnvasado = categoria.toLowerCase().includes('envasado');

      return {
        material: categoria,
        cantidad: tieneReciclado ? cantidadTon : 0,
        unidad: tieneReciclado ? 'ton' : 'ton',
        // renovable: incluyeEnvasado ? 'sí' : 'no',
        proveedor: tieneReciclado ? (incluyeEnvasado ? 'Externo' : 'Interno') : '',
        datos: 'Obtenido directamente',
        metodo: 'Protocolo GEI Estándard Corporativo'
      };
    });

    const totalCantidad302 = materials302.reduce((sum, item) => sum + item.cantidad, 0);
    materials302.push({
      material: 'Total de insumos reciclados utilizados',
      cantidad: parseFloat(totalCantidad302.toFixed(1)),
      unidad: 'ton',
      // renovable: '',
      proveedor: '',
      datos: '',
      metodo: ''
    });

    const porcentaje = totalCantidad301 > 0 ? ((totalCantidad302 / totalCantidad301) * 100).toFixed(2) + '%' : '0.00%';

    materials302.push({
      material: 'Porcentaje de insumos reciclados',
      cantidad: porcentaje,
      unidad: '',
      proveedor: '',
      datos: '',
      metodo: ''
    });

    return {
      materials301,
      materials302
    };
  } catch (error) {
    const msgError = error.response?.data?.message || 'Servicio no disponible';
    console.error(msgError);
    throw new Error(msgError);
  }
}

export function formatExcelMaterials301Gri(materialsData) {
  let result = [];

  result.push({
    Indicador: '301-1',
    '': 'Material',
    ' ': 'Cantidad',
    '  ': 'Unidad(Ton)',
    '301-Materiales': '¿Es renovable?',
    '   ': 'Proveedor',
    '    ': 'Datos',
    '     ': 'Método de estimación / Estándar'
  });

  materialsData.forEach((material) => {
    result.push({
      Indicador: '',
      '': material.material,
      ' ': material.cantidad,
      '  ': material.unidad,
      '301-Materiales': material.renovable,
      '   ': material.proveedor,
      '    ': material.datos,
      '     ': material.metodo
    });
  });

  return result;
}

export function formatExcelMaterials302Gri(materialsData) {
  let result = [];

  result.push({
    Indicador: '301-2',
    '': 'Material',
    ' ': 'Cantidad reciclada utilizada',
    'Insumos reciclados utilizados': 'Unidad(Ton)',
    // 'Insumos reciclados utilizados': '¿Es renovable?',
    '  ': 'Datos',
    '   ': 'Método de estimación / Estándar'
  });

  materialsData.forEach((material) => {
    result.push({
      Indicador: '',
      '': material.material,
      ' ': material.cantidad,
      'Insumos reciclados utilizados': material.unidad,
      // '301-Materiales': material.renovable,
      // '  ': material.proveedor,
      '  ': material.datos,
      '   ': material.metodo
    });
  });

  return result;
}

export function formatExcelMaterials303Gri(materialsData) {
  let result = [];

  result.push({
    Indicador: '301-3',
    '': 'Material',
    ' ': 'Cantidad recuperada',
    '  ': 'Unidad(Ton)',
    'Insumos reciclados Productos y materiales de envasado recuperados': '¿Es renovable?',
    '   ': 'Datos',
    '    ': 'Método de estimación / Estándar'
  });

  return result;
}

//APARTADO 302 - ENERGIA
export function getElectricityGri() {
  // AQUI SE GENERARIA LA LLAMADA AL EP
  return 0;
}

export function formatExcelEnergy301(energyData) {
  let result = [];
  result.push({
    Indicador: '302-1',
    '': 'Energia',
    'Consumo total de energía de fuentes no renovables': 'Consumo en MWh',
    ' ': 'Consumo en GJ',
    '  ': 'Metodología / supuestos'
  });

  return result;
}

export function formatExcelEnergyNis4(energyData) {
  let result = [];
  result.push({
    Indicador: '302-Nis4',
    '': 'Combustible',
    'Consumo total de combustibles de fuentes no renovables': 'Consumo en litros',
    ' ': 'Consumo en GJ',
    '  ': 'Metodología / supuestos'
  });

  return result;
}

export function formatExcelEnergyNis5(energyData) {
  let result = [];
  result.push({
    Indicador: '302-Nis5',
    '': 'Fuente',
    'Consumo total de energía de fuentes renovables': 'Consumo en MWh',
    ' ': 'Consumo en GJ'
  });
  return result;
}

export function formatExcelEnergy302(energyData) {
  let result = [];
  result.push({
    Indicador: '302-2',
    '': 'Tipo',
    'Consumo total de combustibles fuera de la organizacion': 'Consumo en MWh',
    ' ': 'Consumo en GJ'
  });
  return result;
}

export function formatExcelEnergy303(energyData) {}
